import { Routes, Route } from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import Portfolio from "./pages/Portfolio";
import PortfolioDetail from "./pages/PortfolioDetail";

export default function HolladaiRoutes() {
  return (
    <Routes>
      <Route index element={<Dashboard />} />

      {/* Portfolio Routes */}
      <Route path="portfolio" element={<Portfolio />} />
      <Route path="portfolio/:hotelId/detail" element={<PortfolioDetail />} />
    </Routes>
  );
}
